module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" Copyright © 2014 by Houghton Mifflin Harcourt Publishing Company")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Introduction copyright © 2014 by Jennifer Egan")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ALL RIGHTS RESERVED")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("The Best American Series"), _c('sup', [_vm._v("®")]), _vm._v(" and "), _c('em', [_vm._v("The Best American Short Stories")]), _c('sup', [_vm._v("®")]), _vm._v(" are registered trademarks of Houghton Mifflin Harcourt Publishing Company.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("No part of this work may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying and recording, or by any information storage or retrieval system without the proper written permission of the copyright owner unless such copying is expressly permitted by federal copyright law. With the exception of nonprofit transcription in Braille, Houghton Mifflin Harcourt is not authorized to grant permission for further uses of copyrighted selections reprinted in this book without the permission of their owners. Permission must be obtained from the individual copyright owners as identified herein. Address requests for permission to make copies of Houghton Mifflin Harcourt material to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, NY 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com/popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISSN")]), _vm._v(" 0067-6233")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-81922-8")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-86886-8 (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("e"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-81924-2"), _c('br'), _vm._v("\nv1.0914")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("“Charity” by Charles Baxter. First published in "), _c('em', [_vm._v("McSweeney’s")]), _vm._v(", Issue 43. Copyright © 2013 by Charles Baxter. Reprinted by permission of Darhansoff and Verrill literary agency.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“The Indian Uprising” by Ann Beattie. First published in "), _c('em', [_vm._v("Granta")]), _vm._v(", No. 126. Copyright © 2014 by Anne Beattie. Reprinted by permission of the author.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“The Night of the Satellite” by T. Coraghessan Boyle. First published in "), _c('em', [_vm._v("The New Yorker")]), _vm._v(", April 15, 2013. from "), _c('em', [_vm._v("T. C. Boyle Stories II: The Collected Stories of T. Coraghessan Boyle")]), _vm._v(", copyright © 2013 by T. Coraghessan Boyle. Used by permission of Viking Penguin, a division of Penguin Group (USA) LLC.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“After the Flood” by Peter Cameron. First published in "), _c('em', [_vm._v("Subtropics")]), _vm._v(", Issue 15. Copyright © 2013 by Peter Cameron. Reprinted by permission of Irene Skolnick Literary Agency.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Long Tom Lookout” by Nicole Cullen. First published in "), _c('em', [_vm._v("Idaho Review")]), _vm._v(", vol. XIII. Copyright © 2013 by Nicole Cullen. Reprinted by permission of Nicole Cullen.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Medium Tough” by Craig Davidson. First published in "), _c('em', [_vm._v("Agni")]), _vm._v(", #77. Copyright © 2013 by Craig Davidson. Reprinted by permission of the author.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“The Breeze” by Joshua Ferris. First published in "), _c('em', [_vm._v("The New Yorker")]), _vm._v(", September 30, 2013. Copyright © 2014 by Joshua Ferris. Reprinted by permission of the author.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Hover” by Nell Freudenberger. First published in "), _c('em', [_vm._v("The Paris Review")]), _vm._v(", #207. Copyright © 2013 by Nell Freudenberger. Reprinted by permission of Nell Freudenberger.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“A Hand Reached Down to Guide Me” by David Gates. First published in "), _c('em', [_vm._v("Granta")]), _vm._v(", no. 126. Copyright © 2013 by David Gates. Reprinted by permission of David Gates.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“At the Round Earth’s Imagined Corners” by Lauren Groff. First published in "), _c('em', [_vm._v("Five Points")]), _vm._v(". Copyright © 2013 by Lauren Groff. Reprinted by permission of the author.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“The Judge’s Will” by Ruth Prawer Jhabvala. First published in "), _c('em', [_vm._v("The New Yorker")]), _vm._v(", March 25, 2013. Copyright © 2013 by Ruth Prawer Jhabvala. Reprinted by permission of C.S.H. Jhabvala.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Evie M.” by O. A. Lindsey. First published in "), _c('em', [_vm._v("Iowa Review")]), _vm._v(", vol. 43, no. 1. Copyright © 2014 by O. A. Lindsey. Reprinted by permission of O. A. Lindsey.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Kattekoppen” by Will Mackin. First published in "), _c('em', [_vm._v("The New Yorker")]), _vm._v(", March 11, 2013. Copyright © 2013 by Will Mackin. Reprinted by permission of Will Mackin.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“This Is Not a Love Song” by Brendan Mathews. First published in "), _c('em', [_vm._v("Virginia Quarterly Review")]), _vm._v(", 89/3. Copyright © 2013 by Brendan Mathews. Reprinted by permission of Brandt and Hochman Literary Agents, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“La Pulchra Nota” by Molly McNett. First published in "), _c('em', [_vm._v("Image")]), _vm._v(", no. 78. Copyright © 2014 by Molly McNett. Reprinted by permission of the author.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“God” by Benjamin Nugent. First published in "), _c('em', [_vm._v("The Paris Review")]), _vm._v(", #206. Copyright © 2013 by Benjamin Nugent. Reprinted by permission of the author.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Mastiff” by Joyce Carol Oates. First published in "), _c('em', [_vm._v("The New Yorker")]), _vm._v(", July 1, 2013. Copyright © 2014 by Ontario Review, Inc. Reprinted by permission of Joyce Carol Oates.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Next to Nothing” by Stephen O’Connor. First published in "), _c('em', [_vm._v("Conjunctions:")]), _vm._v(" 60. Copyright © 2013 by Stephen O’Connor. Reprinted by permission of the author.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Madame Bovary’s Greyhound” by Karen Russell. First published in "), _c('em', [_vm._v("Zoetrope: All-Story")]), _vm._v(", vol. 17, no. 2. Copyright © 2013 by Karen Russell. Reprinted by permission of Denise Shannon Literary Agency, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Antarctica” by Laura van den Berg. First published in "), _c('em', [_vm._v("Glimmer Train")]), _vm._v(", Issue 88, Fall 2013. From "), _c('em', [_vm._v("The Isle of Youth")]), _vm._v(" by Laura van den Berg. Copyright © 2013 by Laura van den Berg. Reprinted by permission of Farrar, Straus and Giroux.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133015e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0